// extracted by mini-css-extract-plugin
module.exports = {"bar":"BreadcrumbBar_bar__2gqQN","crumb":"BreadcrumbBar_crumb__3M_lr","crumbIcon":"BreadcrumbBar_crumbIcon__1rQZJ"};